import React from 'react'
import FindPassword from 'src/components/accout/FindPassword';
// import FindPassword from 'src/components/accout/FindPassword';


// interface LocationState {
//     from: {
//         pathname: string
//     }
// }

function FindPasswordPage() {
    // const location = useLocation()
    // const { from } = location.state as LocationState

    const isAuthenticated = false

    return isAuthenticated ? <div>계정 유효</div> : <FindPassword />
}

export default FindPasswordPage
